import { useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function DateField({label,value,placeholder,onChange,disabled,error,errorMessage,translateError=false,isRequird=false,fullWidth=true,today=false,time=false}){


    const {t} = useTranslation();
    

    return (
        <div className={`${fullWidth ? 'full-width-datepicker': ''} min-h-[40px] w-[100%] mb-[10px] relative`}>
            { label && <label htmlFor={label} className="text-grey-900 text-[14px] font-[600] leading-[21px] mb-[3px] block">{label}{isRequird && <span className="text-danger">*</span>}</label> }
            <DatePicker 
                showTimeSelect={time}
                dateFormat={time ? 'dd/MM/YYY hh:mm aa' : 'dd/MM/YYYY'}
                minDate={today ? new Date() : null}
                popperPlacement="bottom-start"
                selected={value} 
                placeholderText={placeholder} 
                onChange={onChange} 
                className={`text-grey-600 transition-[border] !border-grey-300 ease-in-out duration-300 focus:border-lightBlue outline-none px-[12px] h-[48px] text-[16px] w-[100%] bg-white rounded-[8px] border justify-start items-center inline-flex leading-[48px] ${ error ? '!border-danger' : '' } ${ disabled ? '!bg-disabled !border-disabled' : '' }`}
            />
            {errorMessage && <p className="text-danger text-[14px] font-[400] leading-[20px] pe-[5px] pt-[3px] mb-[0] block"><img src="/assets/images/error.svg" alt="" className="inline w-[16px] h-[16px] align-middle me-[3px]" />{translateError ? t(errorMessage) : errorMessage}</p>}
        </div>
    )
}